import { createTypes, createActions, createReducer } from './util'
import _ from 'lodash/fp'

const namespace = 'teeCache'

const typeKeys = [
  'RESET',
  'SET'
]

export const types = createTypes(typeKeys, namespace)

export const actions = createActions(types)

const initialState = {
  // guideId -> { courseId -> teeId }
}

const reducer = {
  [types.RESET]: p => _.constant(initialState),
  [types.SET]: p => _.set(
    _.toString(_.get('guideId', p)),
    _.get('selectedTees', p))
}

export default createReducer(initialState, reducer)
